__webpack_require__.p = "https://bmidxbbelgiumfrplpreprod.netlify.app/";